export default __webpack_public_path__ + "static/media/portion.84e5e89f.svg";